import React, { ReactElement, useEffect, Suspense, lazy } from "react";
import { ManiWrapper, FooterWrapper } from "./subcomponents";
import styled from "styled-components";
import Aos from "aos";
import Header from "../components/Header";
import Hero from "../components/Hero";

const About = lazy(() => import("../components/About"));
const Projects = lazy(() => import("../components/Projects"));
const Contact = lazy(() => import("../components/Contact"));

const MainContent = styled.div`
  padding-top: 80px;

  @media (max-width: 768px) {
    padding-top: 70px;
  }

  @media (max-width: 480px) {
    padding-top: 65px;
  }
`;

const FooterContent = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 600px) {
    padding: 0 15px;
  }
`;

const FooterInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    gap: 20px;
    flex-direction: column;
  }
`;

const FooterInfoItem = styled.div`
  text-align: center;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const FooterInfoLabel = styled.p`
  color: #ff014f;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;

  @media (max-width: 600px) {
    font-size: 11px;
  }
`;

const FooterInfoText = styled.p`
  color: #878e99;
  font-size: 14px;
  word-break: break-word;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #333;
  padding-top: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const FooterText = styled.p`
  color: #878e99;
  font-size: 12px;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 11px;
  }
`;

const FooterTitle = styled.h4`
  color: #fff;
  margin-bottom: 10px;
  font-size: 18px;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const FooterSubtitle = styled.p`
  color: #878e99;
  font-size: 14px;
  line-height: 1.6;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

const Home = (): ReactElement => {
  useEffect(() => {
    Aos.init({
      duration: 900,
      once: true, // Better performance - animations only play once
      offset: 100,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <ManiWrapper>
      <a
        href="#home"
        style={{
          position: "absolute",
          left: "-9999px",
          zIndex: 9999,
        }}
        onFocus={(e) => {
          e.target.style.left = "auto";
          e.target.style.top = "10px";
          e.target.style.padding = "10px 20px";
          e.target.style.background = "#ff014f";
          e.target.style.color = "#fff";
          e.target.style.borderRadius = "5px";
          e.target.style.textDecoration = "none";
        }}
        onBlur={(e) => {
          e.target.style.left = "-9999px";
        }}
      >
        Skip to main content
      </a>
      <Header />
      <MainContent>
        <div data-aos="fade-up">
          <Hero />
          <Suspense
            fallback={
              <div style={{ minHeight: "400px", background: "#212428" }} />
            }
          >
            <About />
            {/* <Experience /> */}
            <Projects />
            <Contact />
          </Suspense>
          <FooterWrapper>
            <FooterContent>
              <div style={{ marginBottom: "20px" }}>
                <FooterTitle>Manojkumar Sekar</FooterTitle>
                <FooterSubtitle>
                  Full Stack Developer | React Specialist | Freelancer
                </FooterSubtitle>
              </div>

              <FooterInfo>
                <FooterInfoItem>
                  <FooterInfoLabel>EMAIL</FooterInfoLabel>
                  <FooterInfoText>
                    manojkumar.sekar2000@gmail.com
                  </FooterInfoText>
                </FooterInfoItem>
                <FooterInfoItem>
                  <FooterInfoLabel>LOCATION</FooterInfoLabel>
                  <FooterInfoText>Bangalore, India</FooterInfoText>
                </FooterInfoItem>
                <FooterInfoItem>
                  <FooterInfoLabel>EXPERIENCE</FooterInfoLabel>
                  <FooterInfoText>3+ Years</FooterInfoText>
                </FooterInfoItem>
              </FooterInfo>

              <FooterBottom>
                <FooterText>© 2024 Manojkumar. All rights reserved.</FooterText>
                <FooterText>Designed & Built with ❤️ by Manojkumar</FooterText>
              </FooterBottom>
            </FooterContent>
          </FooterWrapper>
        </div>
      </MainContent>
    </ManiWrapper>
  );
};

export default Home;
